import { Fragment, React, Suspense, useQuery, useState } from 'libs/react';
import { lazy } from 'react';
import { getConfigurationFieldValue } from 'helpers/ConfigurationField';
import { useDealConfiguratorContext } from 'modules/deal/DealConfigureScreen';
import { Button } from 'components/Button';
import { Text } from 'components/Text';
import { TermSelect } from 'modules/config/term/components/TermSelect';
import { useUser } from 'components/user/UserProvider';
import { TermsQuery } from 'graphql/Term/queries/TermsQuery';
import './DealTermsPanel.scss';
/*
 * Loaded when opened: the terms editor brings Quill, which the quote page does
 * not need until then.
 */
const ModalViewTerms = lazy(() => import('modules/deal/components/section/terms/modal/ModalViewTerms').then((m) => ({ default: m.ModalViewTerms })));
/**
 * @component DealTermsPanel
 * @since 1.0.0
 */
export function DealTermsPanel(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const { deal, style } = Object.assign({ style: 'normal' }, props);
    const { configurationFields, updateDealField } = useDealConfiguratorContext();
    const user = useUser();
    const termSelectInput = user.isContactUser() && ((_c = (_b = (_a = user.user) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.client) === null || _c === void 0 ? void 0 : _c.id)
        ? { partnerId: user.user.contact.client.id }
        : {};
    const [globalTermsData] = useQuery(TermsQuery, {
        variables: {
            input: { partnerId: null, primary: true, limit: 5 }
        }
    });
    const accountTerm = (_f = (_e = (_d = globalTermsData === null || globalTermsData === void 0 ? void 0 : globalTermsData.terms) === null || _d === void 0 ? void 0 : _d.items) === null || _e === void 0 ? void 0 : _e[0]) !== null && _f !== void 0 ? _f : null;
    const [openMdodal, setOpenMdodal] = useState(false);
    const termsAndConditionsEditable = getConfigurationFieldValue(configurationFields, 'TERMS_AND_CONDITIONS_EDITABLE');
    const defaultTerms = getConfigurationFieldValue(configurationFields, 'TERMS_AND_CONDITIONS');
    const termsAndConditions = (_g = deal.termsAndConditions) !== null && _g !== void 0 ? _g : defaultTerms;
    if (deal.termsAndConditions == null) {
        updateDealField('termsAndConditions', termsAndConditions, 'string');
    }
    const onPress = () => {
        setOpenMdodal(true);
    };
    const onClose = () => {
        setOpenMdodal(false);
    };
    const isModified = deal.termsAndConditions != null && deal.termsAndConditions !== '';
    return (React.createElement(Fragment, null,
        React.createElement(Text, { className: "deal-settings-panel-title", value: t('Terms and Conditions') }),
        React.createElement("div", { className: "deal-terms-panel-container" },
            React.createElement(TermSelect, { name: "termsAndConditions", value: (_h = deal.term) === null || _h === void 0 ? void 0 : _h.id, returnType: "object", termsInput: termSelectInput, onChange: (value) => {
                    updateDealField('term', value, 'object');
                } }),
            React.createElement(Button, { style: "picto", picto: "fas pen", size: "small", onPress: onPress, className: "deal-terms-panel-button" }),
            isModified && (React.createElement("span", { className: "deal-terms-panel-modified-badge" }, t('Modified')))),
        openMdodal && (React.createElement(Suspense, { fallback: null },
            React.createElement(ModalViewTerms, { onClose: onClose, accountTerm: accountTerm, term: deal.term, termsAndConditions: termsAndConditions, termsAndConditionsEditable: termsAndConditionsEditable, defaultTerms: defaultTerms })))));
}
